<template>
  <div
    class="pagoda-side-drawer"
    v-show="value"
  >
    <div
      class="side-drawer-bg"
      @click="close"
      :class="animate"
    ></div>
    <div
      class="side-drawer-wrapper animated"
      :style="{'width': width}"
      :class="animate"
    >
      <slot name="title">
        <div
          v-if="title"
          class="_header"
          :class="{'top-border': hasBorder}"
        >
          <pagoda-sub-title>{{title}}</pagoda-sub-title>
          <span class="sub-title">{{subTitle}}</span>
          <i
            class="iconfont icon-chexiao icon-class"
            @click="close"
          ></i>
        </div>
      </slot>
      <div
        class="_body"
        ref="_body"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideDrawer',
  data() {
    return {
      animate: '',
      closing: false,
      hasBorder: false
    }
  },
  props: {
    value: Boolean,
    width: {
      type: String,
      default: '360px'
    },
    title: String,
    subTitle: String,
    beforeClose: Function
  },
  created() {
    if (this.value) {
      this.open()
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.open()
      }
    }
  },
  methods: {
    open() {
      if (this.closing) return
      this.openOperate()
    },
    close() {
      const callback = () => {
        if (this.closing) return
        document.body.style.overflow = ''
        this.animate = 'slideOutRight'
        this.closing = true
        setTimeout(() => {
          this.$emit('input', false)
          this.$emit('close')
          this.closing = false
        }, 250)
      }

      if (this.beforeClose) {
        this.beforeClose(callback)
      } else {
        callback()
      }
    },
    openOperate() {
      document.body.style.overflow = 'hidden'
      this.animate = 'slideInRight'
    }
  },
  mounted() {
    this._body = this.$refs._body
    this._body.addEventListener(
      'scroll',
      () => {
        if (this.subTitle) {
          if (this.$refs._body.scrollTop !== 0) {
            this.hasBorder = true
          } else {
            this.hasBorder = false
          }
        }
      },
      false
    )
  },
  computed: {}
}
</script>
